import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SportsCompetitionEventsWidget" */ './SportsCompetitionEventsWidget'
    ),
  modules: ['./SportsCompetitionEventsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
